import { defineMessages } from 'react-intl-next';

export default defineMessages({
	rovoChatButtonText: {
		id: 'highlight-actions.rovo-chat.button-text',
		defaultMessage: 'Chat',
		description: 'Text for button that opens the Rovo Chat sidebar',
	},
	rovoChatOpenChatTooltip: {
		id: 'highlight-actions.rovo-chat-open-chat.tooltip',
		defaultMessage: 'Open Chat',
		description: 'Tooltip for button that opens the Rovo Chat sidebar',
	},
	rovoChatMoreOptionsTooltip: {
		id: 'highlight-actions.rovo-chat-more-options.tooltip',
		defaultMessage: 'Chat recommendations',
		description: 'Tooltip label for the dropdown menu to show more options',
	},
	rovoChatExplainOptionText: {
		id: 'highlight-actions.rovo-chat-explain-option.text',
		defaultMessage: 'Explain',
		description: 'Text for the "Explain" option in the Rovo Chat more options popup',
	},
	rovoChatSummarizeOptionText: {
		id: 'highlight-actions.rovo-chat-summarize-option.text',
		defaultMessage: 'Summarize',
		description: 'Text for the "Summarize" option in the Rovo Chat more options popup',
	},
	rovoChatSummarizePrompt: {
		id: 'highlight-actions.rovo-chat-summarize-prompt',
		defaultMessage: 'Summarize this: {selectedText}',
		description: 'Prompt for the "Summarize" option in the Rovo Chat more options popup',
	},
	rovoChatExplainPrompt: {
		id: 'highlight-actions.rovo-chat-explain-prompt',
		defaultMessage: 'Explain this: {selectedText}',
		description: 'Prompt for the "Explain" option in the Rovo Chat more options popup',
	},
	rovoChatCustomPromptPlaceholder: {
		id: 'highlight-actions.rovo-chat-custom-prompt.placeholder',
		defaultMessage: 'Ask AI about this',
		description: 'Placeholder text for the custom prompt input in the Rovo Chat more options popup',
	},
});
